import { ACTION } from './actions';

export const xhrRequestReducer = (type, state = {}, action) => {
  switch (action.type) {
    case `${type}_REQUEST`:
      return Object.assign({}, state, {
        isFetching: true,
        httpStatus: null
      });
    case `${type}_SUCCESS`:
      return Object.assign({}, state, {
        isFetching: false,
        data: action.data,
        receivedAt: action.receivedAt,
        httpStatus: null
      });
    case `${type}_FAILURE`:
      return Object.assign({}, state, {
        isFetching: false,
        httpStatus: action.httpStatus ? action.httpStatus : null
      });
    default:
      return state;
  }
};

const loading = (state = 0, action) => {
  switch (action.type) {
    case ACTION.LOADING_ADD:
      return state + 1;
    case ACTION.LOADING_REMOVE:
      return state - 1;
    default:
      return state;
  }
};

const alert = (state = null, action) => {
  switch (action.type) {
    case ACTION.SET_ALERT:
      return action.config === null ? null : action.config;
    default:
      return state;
  }
};

const contentItems = (
  state = {
    isFetching: false,
    byUrl: {}
    // isFetching: false,
    // data: {
    //     url: null,
    //     expanded_object: null,
    //     urltype: null,
    //     cspace: null,
    //     object_id: null
    // },
    // receivedAt: null,
    // httpStatus: null,
  },
  action
) => {
  const key = 'CONTENT_ITEM';
  switch (action.type) {
    case `${key}_SUCCESS`: {
      let byUrl = state.byUrl;
      byUrl = Object.assign({}, byUrl, {
        [action.url]: action.data
      });
      return Object.assign({}, state, {
        byUrl,
        isFetching: false
      });
    }
    case `${key}_REQUEST`:
      return Object.assign({}, state, {
        isFetching: true
      });
    case `${key}_FAILURE`:
      return Object.assign({}, state, {
        isFetching: false
      });
    default:
      return state;
  }
};

const footerStaticText = (
  state = {
    isFetching: false,
    data: {
      content: null,
      static_content: null
    },
    receivedAt: null
  },
  action
) => {
  const key = 'FOOTER_STATIC_TEXT';
  switch (action.type) {
    case `${key}_REQUEST`:
    case `${key}_SUCCESS`:
    case `${key}_FAILURE`:
      return Object.assign({}, state, xhrRequestReducer(key, state, action));
    default:
      return state;
  }
};

const sections = (
  state = {
    isFetching: false,
    byId: {},
    byUrl: {}
  },
  action
) => {
  const key = 'SECTION';
  switch (action.type) {
    case `${key}_SUCCESS`: {
      let byUrl = state.byUrl;
      if (action.data.url) {
        byUrl = Object.assign({}, byUrl, {
          [action.data.url]: action.data.id
        });
      }
      let byId = Object.assign({}, state.byId, {
        [action.data.id]: action.data.response
      });

      let newState = Object.assign({}, state, {
        isFetching: false,
        byUrl,
        byId,
        httpStatus: null
      });

      return newState;
    }
    case `${key}_REQUEST`:
    case `${key}_FAILURE`:
      return Object.assign({}, state, xhrRequestReducer(key, state, action));
    default:
      return state;
  }
};

const articles = (
  state = {
    isFetching: false,
    byId: {},
    byUrl: {},
    httpStatus: null
  },
  action
) => {
  const key = 'ARTICLE';
  switch (action.type) {
    case `${key}_SUCCESS`: {
      let byUrl = state.byUrl;
      if (action.data.url) {
        byUrl = Object.assign({}, byUrl, {
          [action.data.url]: action.data.id
        });
      }

      let byId = Object.assign({}, state.byId, {
        [action.data.id]: action.data.response
      });

      let newState = Object.assign({}, state, {
        isFetching: false,
        byUrl,
        byId,
        httpStatus: null
      });

      return newState;
    }
    case `${key}_REQUEST`:
    case `${key}_FAILURE`:
      return Object.assign({}, state, xhrRequestReducer(key, state, action));
    default:
      return state;
  }
};

const feeds = (
  state = {
    isFetching: false,
    byId: {},
    httpStatus: null,
  },
  action,
) => {
  const key = 'FEEDS';
  switch (action.type) {
    case `${key}_SUCCESS`: {
      const byId = action.data.feed.reduce((acc, feed) => {
        return {
          ...acc,
          [feed._id]: {
            ...feed,
          },
        };
      }, {});

      let newState = Object.assign({}, state, {
        isFetching: false,
        byId,
        httpStatus: null,
      });
      return newState;
    }

    case `${key}_REQUEST`:
    case `${key}_FAILURE`:
      return Object.assign({}, state, xhrRequestReducer(key, state, action));
    default:
      return state;
  }
};

const authorArticles = (
  state = {
    isFetching: false,
    data: { articles: [], author: { name: null, picture: null }, nextOffset: 0, total: 0 },
  },
  action,
) => {
  const key = 'AUTHOR_ARTICLES';

  switch (action.type) {
    case `${key}_REQUEST`:
    case `${key}_FAILURE`: {
      return {
        ...state,
        ...xhrRequestReducer(key, state, action),
      };
    }

    case `${key}_SUCCESS`: {
      const { data } = xhrRequestReducer(key, state, action);
      let articles = [];
      if (data.loadMore) {
        articles = [...state.data.articles];
      }
      articles = [...articles, ...data.apiData.articles];      
      return {
        ...state,
        isFetching: false,
        data: {
          ...state.data,
          total: data.apiData.total,
          nextOffset: data.apiData.next_offset,
          articles,
          author: data.apiData.author,
        },
        httpStatus: data.apiData.httpStatus
      };
    }
    default:
      return state;
  }
};

export default {
  loading,
  alert,
  articles,
  footerStaticText,
  contentItems,
  sections,
  feeds,
  authorArticles
};



// WEBPACK FOOTER //
// ./src/ui/src/reducers.js